export const blockIconsFileCloudDone = (
	<span className='material-symbols-outlined'>cloud_done</span>
);
